module.exports = __webpack_public_path__ + "img/samsung-galaxy-s8.11627e27.jpg";